import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelPopoverMenuItem from '../../voxel/PopoverMenu/VoxelPopoverMenuItem';

export interface ColumnChoiceProps {
  toggle: () => void;
  visible: boolean;
  title?: string;
  disabled?: boolean;
}

const ColumnChoice = React.forwardRef<HTMLLIElement, ColumnChoiceProps>(
  ({ toggle, visible, title, disabled }, ref) => {
    return (
      <VoxelPopoverMenuItem
        closePopoverOnClick={false}
        title={title}
        disabled={disabled}
        onClick={toggle}
        icon={
          <FontAwesomeIcon
            icon={visible ? faEye : faEyeSlash}
            className={visible ? '' : 'text-voxel-gray-300'}
          />
        }
      />
    );
  }
);

export default ColumnChoice;
